<div class="mobile-nav-header">
  <button
    class="btn btn-default back-button d-flex align-items-center"
    (click)="close()"
    data-test="backButton">
    <app-icon name="reply" class="mr-1" />
    {{ 'ALPINPRODUCT.productListModal.back' | alpitranslate }}
  </button>
  <h3 class="mobile-nav-header__title m-2">
    {{ 'ALPINPRODUCT.productListModal.header' | alpitranslate }}
  </h3>
</div>
<div class="d-relative">
  @if (cart?.selectedPerson; as person) {
    <div class="person-body pt-2">
      <div class="row m-0 p-0">
        <!-- name input -->
        <div class="col-12 p-0">
          <div class="form-line-normal form-placeholder form-placeholder-small">
            <input
              placeholder=" "
              class="form-input form-input-danger form-input-icon-right"
              type="text"
              autocomplete="nope"
              (click)="focusedName($event)"
              (input)="updateName($event)"
              (blur)="updateName($event)"
              value="{{ person.name }}" />
            <label class="form-label">{{ 'ALPINPRODUCT.productListModal.nameLabel' | alpitranslate }}</label>
            <div class="form-icon form-icon-right text-primary">
              <app-icon name="edit" />
            </div>
          </div>
        </div>
        <!-- age/length select -->
        <div class="col-12 p-0">
          <!-- person age or equipment length-->
          @if (numberOfIntervals() > 3) {
            <div class="form-line-normal form-placeholder form-placeholder-small is-active">
              <select
                class="form-input form-select form-input-danger form-input-icon-right"
                (change)="changeAge($any($event.target).value)">
                @for (ageCategory of ageCategories; track ageCategory) {
                  <optgroup label="{{ getAgeCategoryLabel(ageCategory, translateService.currentLang) }}">
                    @for (ageInterval of ageIntervals.get(ageCategory.id); track ageInterval) {
                      <option
                        value="{{ ageInterval.id }}"
                        [selected]="+person.ageInterval.id === +ageInterval.id">
                        <!-- display age -->
                        @if (!ageInterval.height_start && !ageInterval.height_end) {
                          {{ ageInterval.start }} - {{ ageInterval.end }}
                          {{ 'ALPINPRODUCT.personSwitcher.years' | alpitranslate }}
                        } @else {
                          <!-- display equipment length -->
                          <!-- shop has identical length intervals, add age -->
                          @if (categoryHasIdenticalIntervals(ageCategory.id)) {
                            @if (ageInterval.height_start && ageInterval.height_end) {
                              <div>
                                {{
                                  'ALPINPRODUCT.personSwitcher.equipmentLengthAllWithAge'
                                    | alpitranslate
                                      : {
                                          age_start: ageInterval.start,
                                          age_end: ageInterval.end,
                                          start: ageInterval.height_start,
                                          end: ageInterval.height_end
                                        }
                                }}
                              </div>
                            }
                            @if (ageInterval.height_start && !ageInterval.height_end) {
                              <div>
                                {{
                                  'ALPINPRODUCT.personSwitcher.equipmentLengthFromWithAge'
                                    | alpitranslate
                                      : {
                                          age_start: ageInterval.start,
                                          age_end: ageInterval.end,
                                          start: ageInterval.height_start
                                        }
                                }}
                              </div>
                            }
                            @if (!ageInterval.height_start && ageInterval.height_end) {
                              <div>
                                {{
                                  'ALPINPRODUCT.personSwitcher.equipmentLengthUntilWithAge'
                                    | alpitranslate
                                      : {
                                          age_start: ageInterval.start,
                                          age_end: ageInterval.end,
                                          end: ageInterval.height_end
                                        }
                                }}
                              </div>
                            }
                          } @else {
                            @if (ageInterval.height_start && ageInterval.height_end) {
                              <div>
                                {{
                                  'ALPINPRODUCT.personSwitcher.equipmentLengthAll'
                                    | alpitranslate
                                      : {
                                          start: ageInterval.height_start,
                                          end: ageInterval.height_end
                                        }
                                }}
                              </div>
                            }
                            @if (ageInterval.height_start && !ageInterval.height_end) {
                              <div>
                                {{
                                  'ALPINPRODUCT.personSwitcher.equipmentLengthFrom'
                                    | alpitranslate
                                      : {
                                          start: ageInterval.height_start
                                        }
                                }}
                              </div>
                            }
                            @if (!ageInterval.height_start && ageInterval.height_end) {
                              <div>
                                {{
                                  'ALPINPRODUCT.personSwitcher.equipmentLengthUntil'
                                    | alpitranslate
                                      : {
                                          end: ageInterval.height_end
                                        }
                                }}
                              </div>
                            }
                          }
                        }
                      </option>
                    }
                  </optgroup>
                }
              </select>
              <label class="form-label text-center">
                @if (shop?.usesAgeIntervalLength) {
                  {{ 'ALPINPRODUCT.productListModal.lengthLabel' | alpitranslate }}
                } @else {
                  {{ 'ALPINPRODUCT.productListModal.ageLabel' | alpitranslate }}
                }
              </label>
              <div class="form-icon form-icon-right text-primary">
                <app-icon name="chevronDown" />
              </div>
            </div>
          } @else {
            <div class="age-group">
              <label class="form-label m-0 pl-2">{{
                (shop?.usesAgeIntervalLength
                  ? 'ALPINPRODUCT.productListModal.lengthLabel'
                  : 'ALPINPRODUCT.productListModal.ageLabel'
                ) | alpitranslate
              }}</label>

              <div class="toggle-buttons" role="group">
                @for (ageCategory of ageCategories; track ageCategory) {
                  @for (ageInterval of ageIntervals.get(ageCategory.id); track ageInterval) {
                    <div class="btn-group" role="group">
                      <button
                        type="button"
                        [class.active]="+person.ageInterval.id === +ageInterval.id"
                        class="btn btn-default age-button"
                        (click)="changeAge(ageInterval.id)">
                        <!-- display age -->
                        @if (!ageInterval.height_start && !ageInterval.height_end) {
                          {{ ageInterval.start }} - {{ ageInterval.end }}
                          {{ 'ALPINPRODUCT.personSwitcher.years' | alpitranslate }}
                        } @else {
                          <!-- shop has identical length intervals, add age -->
                          @if (categoryHasIdenticalIntervals(ageCategory.id)) {
                            <ng-container>
                              @if (ageInterval.height_start && ageInterval.height_end) {
                                <div>
                                  {{
                                    'ALPINPRODUCT.productListModal.equipmentLengthAllWithAge'
                                      | alpitranslate
                                        : {
                                            age_start: ageInterval.start,
                                            age_end: ageInterval.end,
                                            start: ageInterval.height_start,
                                            end: ageInterval.height_end
                                          }
                                  }}
                                </div>
                              }
                              @if (ageInterval.height_start && !ageInterval.height_end) {
                                <div>
                                  {{
                                    'ALPINPRODUCT.productListModal.equipmentLengthFromWithAge'
                                      | alpitranslate
                                        : {
                                            age_start: ageInterval.start,
                                            age_end: ageInterval.end,
                                            start: ageInterval.height_start
                                          }
                                  }}
                                </div>
                              }
                              @if (!ageInterval.height_start && ageInterval.height_end) {
                                <div>
                                  {{
                                    'ALPINPRODUCT.productListModal.equipmentLengthUntilWithAge'
                                      | alpitranslate
                                        : {
                                            age_start: ageInterval.start,
                                            age_end: ageInterval.end,
                                            end: ageInterval.height_end
                                          }
                                  }}
                                </div>
                              }
                            </ng-container>
                          } @else {
                            @if (ageInterval.height_start && ageInterval.height_end) {
                              <div>
                                {{
                                  'ALPINPRODUCT.productListModal.equipmentLengthAll'
                                    | alpitranslate
                                      : {
                                          start: ageInterval.height_start,
                                          end: ageInterval.height_end
                                        }
                                }}
                              </div>
                            }
                            @if (ageInterval.height_start && !ageInterval.height_end) {
                              <div>
                                {{
                                  'ALPINPRODUCT.productListModal.equipmentLengthFrom'
                                    | alpitranslate
                                      : {
                                          start: ageInterval.height_start
                                        }
                                }}
                              </div>
                            }

                            @if (!ageInterval.height_start && ageInterval.height_end) {
                              <div>
                                {{
                                  'ALPINPRODUCT.productListModal.equipmentLengthUntil'
                                    | alpitranslate
                                      : {
                                          end: ageInterval.height_end
                                        }
                                }}
                              </div>
                            }
                          }
                        }
                      </button>
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="person-body pt-2">
      <div class="row m-0 p-0">
        <!-- name input -->
        <div class="col-12 p-0">
          <div class="form-line-normal form-placeholder form-placeholder-small">
            <app-skeleton-loader [loaderHeight]="'2.5rem'" />
          </div>
        </div>
        <!-- age/length select -->
        <div class="col-12 p-0">
          <!-- person age or equipment length-->
          <div class="form-line-normal form-placeholder form-placeholder-small is-active">
            <app-skeleton-loader [loaderHeight]="'2.5rem'" />
          </div>
        </div>
      </div>
    </div>
  }

  @if (shop) {
    <hr class="mb-4 mt-2" />
    <div class="bg-danger">
      <app-product-list-categories
        [shopCategories]="
          products | filterProductsBy: cart?.selectedPerson?.ageInterval.age_category.id | productCategories
        "
        [(selectedCategory)]="selectedCategory" />
    </div>
    <app-product-list
      [cart]="cart"
      [products]="
        products | filterProductsBy: cart?.selectedPerson?.ageInterval.age_category.id : selectedCategory
      "
      [companyId]="shop.companyId" />
    @if (cart?.selectedPerson?.productEntities.length) {
      <div class="text-center py-3 close-button">
        <button
          type="button"
          class="btn btn-primary btn-close-button d-flex align-items-center m-auto"
          (click)="close()">
          <app-icon name="arrowLeft" class="mr-2" height="1.5rem" width="1.5rem" />
          <span class="btn-text d-inline-block">{{ 'ALPINPRODUCT.shopInfo.close' | alpitranslate }}</span>
        </button>
      </div>
    }
  }
</div>
<!-- paralell named router outlets are broken somehow. can' navigate to products/(modal:person/0//sideBar:12345). remove me once the navigation on parent works starting with Ang16 maybe -->
<router-outlet name="sideBar"></router-outlet>
